<template>
  <vetster-slide-over
    id="auth-slideover"
    ref="auth"
    container-classes="flex lg:h-auto"
    @close="close(false)"
  >
    <template #header>
      <vetster-slide-over-common-heading
        :header="getHeader"
        :show-back="showBack"
        :show-close="!showBack"
        @back="back"
        @close="close(false)"
      >
        <template>
          <div
            v-if="[AuthFormType.Register, AuthFormType.Socialite].includes(authModalMode)"
            class="mt-1"
          >
            <a
              href="#"
              class="underline text-ocean-950"
              @click.prevent="switchToLogin"
            >
              {{ $t('login.already-have-an-account-login') }}
            </a>
          </div>
          <div v-else-if="getHeaderDescription">
            <p
              class="text-neutral-500"
              v-html="getHeaderDescription"
            />
          </div>
        </template>
      </vetster-slide-over-common-heading>
    </template>

    <template #content>
      <div class="px-standard mt-6 pb-10">
        <vetster-auth-forms
          v-if="authModalMode"
          :auth-mode="authModalMode"
          :global-locale="globalLocale"
          :is-booking="isBooking"
          :is-locale-read-only="isLocaleReadOnly"
          :is-promo-code-readonly="isPromoCodeReadonly || promoCodeReadonly"
          :is-promo-code-required="isPromoCodeRequired || (getPromoCode && promoCodeReadonly)"
          :promo-code="promoCode || getPromoCode"
          :redirect-to-dashboard="redirectToDashboard"
          :show-social="showSocial"
          @action-completed="close(true)"
        />
      </div>
    </template>
  </vetster-slide-over>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import VetsterAuthForms from '@/brand-components/VetsterAuthForms';
import VetsterSlideOver from '@/brand-components/VetsterSlideOver';
import VetsterSlideOverCommonHeading from '@/brand-components/VetsterSlideOverCommonHeading';
import AuthFormType from '@/enums/AuthFormType';

export default {
  name: 'VetsterAuthSlideOver',

  components: {
    VetsterAuthForms,
    VetsterSlideOver,
    VetsterSlideOverCommonHeading,
  },

  props: {
    isLocaleReadOnly: {
      default: false,
      type: Boolean,
    },
    isPromoCodeReadonly: {
      default: false,
      type: Boolean,
    },
    isPromoCodeRequired: {
      default: false,
      type: Boolean,
    },
    promoCode: {
      type: String,
      default: '',
    },
    showModal: {
      type: Boolean,
      default: false,
    },
    showSocial: {
      type: Boolean,
      default: true,
    },
    titleLogin: {
      type: String,
      default: '',
    },
    modalType: {
      type: String,
      default: AuthFormType.PasswordlessLogin,
      validator(value) {
        return [AuthFormType.Register, AuthFormType.PasswordlessLogin].includes(value);
      },
    },
    redirectToDashboard: {
      default: false,
      type: Boolean,
    },
    globalLocale: {
      default: '',
      type: String,
    },
  },

  data() {
    return {
      AuthFormType,
      headerTitle: null,
      headerDescription: null,
    };
  },

  computed: {
    ...mapGetters('authModal', [
      'authModalMode',
      'getHeader',
      'getHeaderDescription',
      'isBooking',
      'promoCodeReadonly',
      'resetPasswordStep',
    ]),
    ...mapGetters('authModal', {
      getPromoCode: 'promoCode',
    }),
    ...mapGetters('emailVerification', [
      'showChannelVerification',
      'showEmailVerification',
    ]),
    showBack() {
      return [
        AuthFormType.OTP,
        AuthFormType.PasswordLogin,
        AuthFormType.PasswordReset,
        AuthFormType.Register,
        AuthFormType.Socialite,
      ].includes(this.authModalMode);
    },
  },

  watch: {
    authModalMode(val) {
      if (val) {
        this.setHeader(val);
        this.$refs.auth?.open();
      } else {
        this.$refs.auth?.close();
      }
    },
  },

  mounted() {
    if (this.showModal) {
      this.setAuthModalMode(this.modalType);
    }
  },

  methods: {
    ...mapActions('authModal', [
      'closeAuthModal',
      'setAuthModalMode',
    ]),
    close(success) {
      this.closeAuthModal(success);
      this.$emit('close');
    },
    switchMode(mode) {
      this.setAuthModalMode(mode);
    },
    setHeader(mode) {
      let header;
      let headerDescription;
      switch (mode) {
        case AuthFormType.Register:
          header = this.$t('login.finish-signing-up');
          break;
        case AuthFormType.Socialite:
          header = this.$t('login.confirm-account-details');
          break;
        case AuthFormType.PasswordlessLogin:
          header = this.titleLogin || this.$t('login.login-or-sign-up');
          break;
        case AuthFormType.PasswordReset:
          header = this.$t('login.reset-your-password');
          headerDescription = this.$t('login.enter-your-email');
          break;
        default:
          break;
      }
      this.$store.commit('authModal/setHeader', header);
      this.$store.commit('authModal/setHeaderDescription', headerDescription);
    },
    back() {
      switch (this.authModalMode) {
        case AuthFormType.Register:
        case AuthFormType.OTP:
        case AuthFormType.PasswordLogin:
        case AuthFormType.Socialite:
          this.switchMode(AuthFormType.PasswordlessLogin);
          break;
        case AuthFormType.PasswordReset:
          if (this.resetPasswordStep === 'email') {
            this.switchMode(AuthFormType.PasswordLogin);
          } else {
            this.$store.commit('authModal/setResetPasswordStep', 'email');
          }
          break;
        default:
          break;
      }
    },
    switchToLogin() {
      setTimeout(() => {
        this.switchMode(AuthFormType.PasswordlessLogin);
      }, 100);
    },
  },
};
</script>
